import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=263a6346"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports